import { useEffect, useState } from 'react';
import { RouterProvider } from 'react-router';
import i18next from './i18next';
import { router } from './AppRouter';
import ConfigContextProvider from './shared/context/ConfigContext';
import PostHogProviderWrapper from './shared/context/PostHogContext';
import LanguageContextProvider from './shared/context/LanguageContext';
import { AlertBarContextProvider } from './shared/context/AlertBarContext';
import Spinners from './shared/components/Spinner';

function App() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    i18next.on('loaded', () => setReady(true));

    return () => i18next.off('loaded');
  }, []);

  if (!i18next.isInitialized) {
    return <Spinners />;
  }

  if (ready) {
    return (
      <AlertBarContextProvider>
        <ConfigContextProvider>
          <PostHogProviderWrapper>
            <LanguageContextProvider>
              <RouterProvider router={router} />
            </LanguageContextProvider>
          </PostHogProviderWrapper>
        </ConfigContextProvider>
      </AlertBarContextProvider>
    );
  }

  return <Spinners />;
}

export default App;
